module.exports = __webpack_public_path__ + "img/Manuel-5.abf899d0.jpg";